import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { getLiteralsLogin } from "./services/literals";
import { getLang } from "../utils/getLang";
export default () => {
  const [loading, setLoading] = useState(true);
  const [literals, setLiterals] = useState();
  const lang = getLang();
  const t = useCallback((key, params) => {
    let literal = (literals === null || literals === void 0 ? void 0 : literals[key]) || key;
    if (params && params.length > 0 && literal) {
      literal = literal.replace(/%([0-9]+)\$s/g, '%@');
      if (literal.includes('%@')) {
        const appearances = literal.match(new RegExp('%@', 'g')).length;
        for (let i = 0; i < appearances && i < params.length; i++) {
          literal = literal.replace('%@', params[i]);
        }
      }
    }
    return literal;
  }, [literals]);
  const getLiteralWithParametersHtml = useCallback(function (literal, params, customizeParameter) {
    if (params === void 0) {
      params = [];
    }
    let result = t(literal);
    if (params && params.length > 0 && result) {
      result = result.replace(/%([0-9]+)\$s/g, '%@');
      if (result.includes('%@')) {
        const appearances = result.match(new RegExp('%@', 'g'));
        let lastIndex = 0;
        let resultParts = [];
        appearances.forEach((app, index) => {
          const currentIndex = result.indexOf('%@', lastIndex);
          resultParts.push(result.slice(lastIndex, currentIndex));
          resultParts.push(customizeParameter ? customizeParameter(params[index], index) : params[index]);
          lastIndex = currentIndex + 2;
        });
        if (lastIndex < result.length) {
          resultParts.push(result.slice(lastIndex, result.length));
        }
        return /*#__PURE__*/React.createElement(Fragment, null, resultParts.map((part, index) => typeof part === 'object' ? _objectSpread(_objectSpread({}, part), {}, {
          key: `part-${index}`
        }) : part));
      }
    }
    return result;
  }, [t]);
  useEffect(() => {
    if (literals) return;
    getLiteralsLogin(lang).then(_ref => {
      let {
        data
      } = _ref;
      setLiterals(data || {});
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      console.error(e);
    });
  }, [lang, literals]);
  return {
    loading,
    t,
    lang,
    getLiteralWithParametersHtml
  };
};